module.exports = __webpack_public_path__ + "media/customizations/lifeatkiawahriver/logo-e81b37f83235c2f92ea8daecb4830b91.png";